import React, { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login, user, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@roofquote.pro");
  const [password, setPassword] = useState("Admin@123");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!loading && user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) navigate("/");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen flex auth-grid">
      <div className="hidden lg:flex flex-col justify-between w-1/2 p-12 bg-[#0F172A] text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-30"
          style={{
            backgroundImage: "linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)",
            backgroundSize: "32px 32px",
          }}
        />
        <div className="relative">
          <div className="flex items-center gap-2.5">
            <div className="w-10 h-10 grid place-items-center bg-[var(--rqp-orange)] rounded-sm">
              <svg viewBox="0 0 24 24" className="w-6 h-6" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinejoin="round">
                <path d="M3 12 L12 4 L21 12 L18 12 L18 20 L6 20 L6 12 Z" />
              </svg>
            </div>
            <div>
              <div className="font-display font-bold text-lg leading-none">RoofQuote</div>
              <div className="text-[10px] font-bold tracking-[0.18em] text-[var(--rqp-orange)] uppercase">PRO</div>
            </div>
          </div>
        </div>
        <div className="relative">
          <div className="overline text-slate-400 mb-4">Built for UK contractors</div>
          <h1 className="font-display text-4xl lg:text-5xl font-bold leading-[1.05] tracking-tight">
            Measure. Calculate. <span className="text-[var(--rqp-orange)]">Quote.</span>
          </h1>
          <p className="mt-5 text-slate-300 max-w-md text-[15px] leading-relaxed">
            The roofing estimating tool that turns site measurements into professional, profitable quotes in minutes &mdash; from gable to mansard.
          </p>
        </div>
        <div className="relative grid grid-cols-3 gap-6 text-sm">
          {[
            ["16+", "Roof Types"],
            ["100%", "Auto Calcs"],
            ["PDF", "Quote Export"],
          ].map(([n, l]) => (
            <div key={l}>
              <div className="font-mono-data text-2xl font-bold text-[var(--rqp-orange)]">{n}</div>
              <div className="text-xs text-slate-400 mt-1">{l}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="flex-1 grid place-items-center p-6">
        <form onSubmit={submit} className="card-elev w-full max-w-md p-10" data-testid="login-form">
          <span className="hero-rule" />
          <div className="overline">Sign in</div>
          <h2 className="font-display text-4xl font-bold tracking-tight mt-2">Welcome back</h2>
          <p className="text-sm text-slate-500 mt-2">Enter your credentials to continue.</p>

          {error && (
            <div className="mt-4 text-sm text-red-700 bg-red-50 border border-red-200 px-3 py-2 rounded-sm" data-testid="login-error">
              {error}
            </div>
          )}

          <label className="block mt-6">
            <span className="overline">Email</span>
            <input
              data-testid="login-email-input"
              type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} className="rqp mt-1.5"
              autoComplete="email"
            />
          </label>
          <label className="block mt-4">
            <span className="overline">Password</span>
            <input
              data-testid="login-password-input"
              type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)} className="rqp mt-1.5"
              autoComplete="current-password"
            />
          </label>

          <button
            data-testid="login-submit-button"
            type="submit" disabled={submitting}
            className="btn-primary w-full mt-6 disabled:opacity-60"
          >
            {submitting ? "Signing in…" : "Sign in"}
          </button>

          <div className="mt-6 text-sm text-slate-600">
            New to RoofQuote Pro?{" "}
            <Link to="/register" data-testid="login-to-register-link" className="text-[var(--rqp-orange)] font-semibold hover:underline">
              Create an account
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
